import { useCallback, useEffect } from 'react';

import { initStore } from '../save-to-list-store';

import type { Configs } from '@shared/types/configs';
import type { I18nService } from '@shared/types/i18n';
import type { UserContext } from '@shared/types/user-context';

import useUpdatedActionAfterLogingIn from '@shared/utils-frontend/hooks/useActionAfterLoggingIn';

type Props = {
  userContext: UserContext;
  i18n: I18nService;
  configs: Configs;
};

const useSaveToListInteraction = ({ configs, i18n, userContext }: Props) => {
  const { isLoggedIn } = userContext.userPreferences;

  const initSaveToListStore = useCallback(async () => {
    await initStore({
      i18n,
      configs,
    });
  }, [i18n, configs]);

  useUpdatedActionAfterLogingIn({
    callback: initSaveToListStore,
  });

  useEffect(() => {
    if (isLoggedIn) {
      initSaveToListStore();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useSaveToListInteraction;
